// Core
import React, { Component } from 'react';

// Styles
import './index.scss';

class NumberRing extends Component {
  getNumberColor(number) {
    if (number > this.props.highBreakpoint) {
      return this.props.lowRingColor;
    } else if (number <= this.props.lowBreakpoint) {
      return this.props.highRingColor;
    }
    return this.props.ringColor;
  }

  getIcon(numberColor) {
    return (
      <div
        className="NumberRing-icon"
        style={{ height: this.props.radius * 2 }}
      >
        <i color={numberColor} className="fas fa-check"></i>
      </div>
    );
  }

  getNumberText() {
    const numberColor = this.getNumberColor(this.props.number);

    const fontSize = this.props.radius >= 29 ? '14px' : '9px';
    const style = {
      fontFamily: 'inherit',
      fontSize: fontSize,
    };
    const strokeWidth = this.props.radius >= 29 ? '1px' : '0.5px';
    return (
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        stroke={`${numberColor}`}
        style={style}
        strokeWidth={`${strokeWidth}`}
        dy=".3em"
      >
        {this.props.number}
      </text>
    );
  }

  render() {
    // const {radius, stroke, backgroundRingColor, number, circumferenceOffset } = this.props;
    const { radius, stroke, number, circumferenceOffset } = this.props;
    const normalizedRadius = radius - stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const numberColor = this.getNumberColor(this.props.number);

    const style = {
      height: radius * 2,
    };

    const loadClass = isNaN(this.props.number) ? 'circle-loading' : '';

    return (
      <div className={`number-ring-container ${loadClass}`} style={style}>
        {this.props.number === 0 ? (
          <div
            className="NumberRing-icon"
            style={{ height: this.props.radius * 2 }}
          >
            <i className="fas fa-check"></i>
          </div>
        ) : null}
        <svg height={radius * 2} width={radius * 2}>
          <circle
            className={!this.props.isPercentage ? 'inverted' : ''}
            stroke={numberColor}
            fill="transparent"
            strokeWidth={stroke}
            strokeDasharray={circumference + ' ' + circumference}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          {this.props.number !== 0 ? this.getNumberText() : null}
        </svg>
      </div>
    );
  }
}

NumberRing.defaultProps = {
  number: 0,
  radius: 30,
  stroke: 3,
  backgroundRingColor: '#E2E8F0',
  // Default colors
  highRingColor: '#22C55E',
  ringColor: '#F97316',
  lowRingColor: '#E11D48',
  // Default breakpoints
  highBreakpoint: 100,
  lowBreakpoint: 50,
};

export default NumberRing;
